import styled from 'styled-components';

export const Container = styled.div`
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100000;
    display: flex;
`;

export const MobileContainer = styled(Container)`
    padding: 30px;
    justify-content: center;
    align-items: center;
`;

export const Content = styled.div`
    margin-left: 220px;
    width: calc(100vw - 220px);
    height: 100%;
    background-color: #0e0e0e;
    padding: 16px;
`;



// WEBPACK FOOTER //
// ./src/UI/Containers/GymAdminPanel/style.js